module.exports = __webpack_public_path__ + "static/media/solar-panel.a1e04a41.jpg";